import React, { Component } from 'react'
import ReactDOM from 'react-dom'
import $ from 'lib/jquery'
import PropTypes from 'prop-types'
import classNames from 'classnames'
import { Reveal } from 'foundation-sites'
import CommonIcons from 'frontend/components/common-icons'

export default class ActionModal extends Component {
  constructor (props) {
    super(props)
    this.isReallyOpen = false
    this.handleOpen = this.handleOpen.bind(this)
    this.handleClose = this.handleClose.bind(this)
    this.close = this.close.bind(this)
    this.modalRef = React.createRef()
  }

  componentDidMount () {
    this.reveal = new Reveal(this.modalElement, {})
    this.modalElement.on('open.zf.reveal', this.handleOpen)
    if (this.props.isOpen) this.open()
  }

  componentWillUnmount () {
    this.modalElement.off('closed.zf.reveal', this.handleClose)
    this.modalElement.off('open.zf.reveal', this.handleOpen)
    setTimeout(() => {
      if (this.isReallyOpen) { this.close() }
      this.reveal.destroy()
    })
  }

  componentDidUpdate (prevProps) {
    if (prevProps.isOpen !== this.props.isOpen) this.props.isOpen ? this.open() : this.close()
  }

  get modalElement () {
    return this._modalElement || (this._modalElement = $(this.modalRef.current))
  }

  open () {
    this.reveal.open({ overlay: false })
  }

  close () {
    this.reveal.close()
  }

  handleOpen () {
    this.isReallyOpen = true
    this.modalElement.on('closed.zf.reveal', this.handleClose)
  }

  handleClose () {
    this.isReallyOpen = false
    this.modalElement.off('closed.zf.reveal', this.handleClose)
    this.modalElement.on('open.zf.reveal', this.handleOpen)
    setTimeout(() => {
      this.props.onClose && this.props.onClose()
    })
  }

  renderTitle () {
    if (this.props.title) return <h1 className="title">{this.props.title}</h1>

    return null
  }

  renderBody () {
    if (this.props.body) return <div className="body">{this.props.body}</div>

    return null
  }

  renderLeftButton () {
    if (this.props.leftButton) {
      return this.props.leftButton
    }

    if (this.props.onLeftClick) {
      return (
        <button className="left" onClick={this.props.onLeftClick}>
          {this.props.leftButtonLabel}
        </button>
      )
    }

    return null
  }

  renderRightButton () {
    if (this.props.rightButton) {
      return this.props.rightButton
    }

    if (this.props.onRightClick) {
      return (
        <button className="right" onClick={this.props.onRightClick}>
          {this.props.rightButtonLabel}
        </button>
      )
    }

    return null
  }

  renderCloseButton () {
    if (this.props.closeButton) { return this.props.closeButton }

    if (this.props.showCloseButton) {
      return (
        <button className="close-button" onClick={this.close}>
          <span aria-hidden="true">
            close
            <CommonIcons item="common-close" className="icon" />
          </span>
        </button>
      )
    }

    return null
  }

  render () {
    const leftButton = this.renderLeftButton()
    const rightButton = this.renderRightButton()
    // extra div fixes "The node to be removed is not a child of this node"
    return ReactDOM.createPortal(
      <div>
        <div
          id={this.props.id}
          className={classNames('reveal', 'action_modal', this.props.className)}
          data-reveal
          data-overlay={this.props.overlay}
          ref={this.modalRef}
          data-close-on-esc="true"
        >
          <div className="container">
            {this.renderTitle()}
            {this.renderBody()}
            {(leftButton || rightButton) && (
              <div className="buttons_place">
                {this.renderLeftButton()}
                {this.renderRightButton()}
              </div>
            )}
          </div>

          {this.renderCloseButton()}
        </div>
      </div>,
      document.body
    )
  }
}

ActionModal.propTypes = {
  isOpen: PropTypes.bool,
  id: PropTypes.string,
  className: PropTypes.string,
  title: PropTypes.oneOfType([PropTypes.string, PropTypes.object]),
  body: PropTypes.oneOfType([PropTypes.string, PropTypes.object]),
  leftButton: PropTypes.object,
  leftButtonLabel: PropTypes.string,
  onLeftClick: PropTypes.func,
  rightButton: PropTypes.object,
  rightButtonLabel: PropTypes.string,
  onRightClick: PropTypes.func,
  onClose: PropTypes.func,
  showCloseButton: PropTypes.bool,
  closeButton: PropTypes.object,
  overlay: PropTypes.bool
}

ActionModal.defaultProps = {
  isOpen: true,
  id: 'actin-modal',
  title: null,
  body: null,
  leftButtonLabel: 'Ok',
  rightButtonLabel: 'Cancel',
  onClose: null,
  showCloseButton: true,
  overlay: true
}
